import React from 'react';
import { Link } from '@reach/router';
import Sidebar from '../components/ui/sidebar';
import ScrollToTopOnMount from '../components/utils/scroll-top';
import BackLink from '../components/utils/back-link';

const Upgrade = props => {
  
    const today = new Date();
  const year = today.getFullYear();
  return (
  <>
  <Sidebar>
        <BackLink/>
    </Sidebar>

  <main className='small-container owl'>

        <p className='txt-bold txt-l -accent txt-uppercase txt-center '>
          Upgrade
        </p>

      <p className="-accent txt-l"> La idea es traer un par de funcionalidades más durante <em className="-highlight">2020.</em> 
       </p>
      <p className="-accent txt-l"> <em className="-highlight">Vanity</em> publicar un perfil público.</p>
      <p className="-accent txt-l">  <em className="-highlight">AfterParty</em> subir una foto de cada partido. </p>

  </main>
  </>
)};

export default Upgrade;
